import { DEFAULT_CANARY_PHASES } from './phase-utils';
import { VariableInfo } from '@/lib/PlannerDTOs';

export const ENABLE_CANARY_ON_OPEN_STATE = 'enableCanaryOnOpen';

export const resolveCanaryEnabled = (
  variable: VariableInfo | undefined,
): boolean => {
  const savedConfig = variable?.metadata?.canaryConfig;

  if (savedConfig?.enabled != null) {
    return savedConfig.enabled;
  }

  // The backend omits false boolean values, so a persisted opt-out can come
  // back with its reason but without an explicit enabled field.
  if (savedConfig?.disabledReason) {
    return false;
  }

  if (variable?.canary?.enabled === true) {
    return true;
  }

  return true;
};

export const enableCanaryForReview = (
  variable: VariableInfo,
): VariableInfo => ({
  ...variable,
  metadata: {
    ...variable.metadata,
    canaryConfig: {
      ...(variable.metadata?.canaryConfig ?? {}),
      enabled: true,
      disabledReason: undefined,
      disabledReasonNote: undefined,
      phases:
        variable.metadata?.canaryConfig?.phases ??
        DEFAULT_CANARY_PHASES.map((phase) => ({ ...phase })),
      metrics: variable.metadata?.canaryConfig?.metrics ?? [],
    },
  },
});
